import { Button, Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { EmailAddress, Password, UserName } from "../../../Constants/Constants";
import { Route } from "../../../Routers/RouteList";
import { dynamicImage, Image } from "../../../Utils";
import BgImage from "../Login/BgImage";
import TermsCondition from "../Login/TermsCondition";
import { useNavigate } from "react-router-dom";

const SignUpContainer = () => {
  const navigate = useNavigate();
  return (
    <div className="login-page">
      <Container fluid className="p-0">
        <Row>
          <Col xs="12" lg="6" className="px-0">
            <div className="left-page">
              <div className="signup-page">
                <div className="login-content w-100">
                  <div className="login-content-header mb-3 text-center">
                    <Image className="image-fluid m-auto" src={dynamicImage("logo/logo.png")} alt="images" />
                  </div>
                  <h3 className="text-center">{"Hello Everyone , We are Chatzy"}</h3>
                  <h6 className="text-center mb-4">{"Welcome to Chatzy please login to your account."}</h6>
                  <Form className="form1">
                    <FormGroup>
                      <Label className="col-form-label">{UserName}</Label>
                      <Input type="text" placeholder="Test User" />
                    </FormGroup>
                    <FormGroup>
                      <Label className="col-form-label">{EmailAddress}</Label>
                      <Input type="email" placeholder="Test@123gmail.com" />
                    </FormGroup>
                    <FormGroup>
                      <Label className="col-form-label">{Password}</Label>
                      <Input type="password" placeholder="Password" autoComplete="off" />
                    </FormGroup>
                  </Form>
                  <FormGroup>
                    <div className="buttons text-center mt-2">
                      <Button color="primary" className="button-effect justify-content-center" onClick={() => navigate(Route.Login)}>Signup</Button>
                    </div>
                  </FormGroup>
                  <TermsCondition socialLinks />
                </div>
              </div>
            </div>
          </Col>
          <BgImage />
        </Row>
      </Container>
    </div>
  );
};

export default SignUpContainer;
